import * as React from "react";
import { Button, ButtonProps } from "react-bootstrap";
import { BsBoxArrowUpRight } from "react-icons/bs";

export function saveFile(blob: Blob, fileName: string) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
}

export function exportFile(
  text: string,
  fileName: string,
  contentType: string,
) {
  saveFile(new Blob([text], { type: contentType }), fileName);
}

interface ExportFileProps {
  text: string;
  fileName: string;
  contentType: string;
  variant?: ButtonProps["variant"];
  size?: ButtonProps["size"];
  disabled: boolean;
  onExport(): string;
}

export function ExportFile(props: ExportFileProps) {
  const { text, fileName, contentType, variant, size, disabled, onExport } =
    props;

  const onClick = () => {
    exportFile(onExport(), fileName, contentType);
  };

  return (
    <span>
      <Button
        variant={variant}
        size={size}
        disabled={disabled}
        onClick={onClick}
      >
        <BsBoxArrowUpRight />
        {text}
      </Button>
    </span>
  );
}
